import { phoneDesc } from ".";

export const userTypeMap = {
  0: "托运人",
  1: "托运人",
  2: "承运人",
  3: "车队长",
  4: "职员",
}

//认证审核状态
export const companyCertificationAuditMap = {
  0: "审核中",
  1: "审核通过（可编辑）",
  2: "修改（审核未通过）",
  3: "提交"
};

//车辆状态
export const carStatusMap = {
  1: "在线",
  2: "离线",
};

//状态 0->申请中(发起申请) 1->完成 2->驳回
export const withdrawalDetailMap = {
  0: { "type": "info", "text": "提现中" },
  1: { "type": "success", "text": "提现成功" },
  2: { "type": "warning", "text": "提现失败" },
};

//个人"消费/退款  1->司机支付定金 2->货主支付保证金 3->退还司机定金 4->退还货主保证金 5->货主支付开票费 6->货主支付服务费 7->货主支付运费
export const personalConsumptionRefundMap = {
  1: "司机支付定金",
  2: "货主支付保证金",
  3: "退还司机定金",
  4: "退还货主保证金",
  5: "货主支付开票费",
  6: "货主支付服务费",
  7: "货主支付运费",
  8: "车队长支付定金",
  9: "退还车队长定金",
  10: "司机收入运费",
  11: "货主收入定金",
};

//"消费/退款  1->企业支付运费 2->企业支付保证金 3->退还企业运单保证金 4->企业支付开票费 5->企业支付服务费
export const consumptionRefundMap = {
  1: "企业支付运费",
  2: "企业支付保证金",
  3: "退还企业运单保证金",
  4: "企业支付开票费",
  5: "企业支付服务费",
  6: "企业收入定金",
  7: "企业支付货物保障服务费",
};

//提现类型
export const withdrawalTypeMap = {
  1: '身份证实名',
  2: '身份证实名+企业认证',
  3: '身份证实名+行驶证认证',
  4: '身份证实名+行驶证认证+经营许可证认证',
}

//用户合同类型
export const contractTypeMap = {
  1: "运输服务承揽协议", //运输服务承揽协议
  2: "订单运输合同", //订单运输合同
};

//钱包记录 类型 0->消费 1->退款 2->收入
export const consumptionListTypeMap = {
  0: "消费",
  1: "退款",
  2: "收入",
};


//评价等级
export const evaluationStarLevelMap = {
  0: { "type": "success", "text": "非常好" },
  1: { "type": "info", "text": "一般" },
  2: { "type": "danger", "text": "差" },
};


export const invoiceTypes = {
  0: "不开发票",
  1: "普票",
  2: "专票"

};

//结算依据1->按装货磅单结算 2->按卸货磅单结算
export const settleTypeMap = [
  {
    text: "按装货磅单结算",
    type: 1
  },
  {
    text: "按卸货磅单结算",
    type: 2
  },
  {
    text: "按磅单重量值最小的结算",
    type: 3
  },
]

//定金类型 0->退还 1->不退还
export const depositTypeMap = [
  {
    text: "退还",
    type: 0, desc: "司机支付订金到平台用于订货押金，订单完成后，退还给司机"
  },
  // {
  //   text: "不退还",
  //   type: 1,
  //   desc: "司机支付订金到平台用于订货押金，订单完成后支付您；信誉等级决定了您订金金额的上限，详情参考信用等级说明"
  // },
]

//跟车种类
export const followCarList = [
  {
    text: "不跟车",
    type: 0,

  },
  {
    text: "1人跟车",
    type: 1,

  },
  {
    text: "2人跟车",
    type: 2,

  }
]
export const followCarTypeList = [
  {
    text: "本人",
    type: 1,
  }, {
    text: "他人",
    type: 2,
  },];

export const freightTypeList = [
  {
    text: "一口价",
    type: 1,
  },
  //  {
  //   text: "电议",
  //   type: 2,
  // },
];



export const demandTypeMap = [
  {
    text: "普通发货",
    type: 1,
  },
  {
    text: "大批量发货",
    type: 2,
  },

]


//待办类型 0->委托运输 1->待装货 2->待验收 3->待评价
export const backlogTypeMap = {
  0: { "text": '委托运输', "btnText": "去接单" },
  1: { "text": '待签协议', "btnText": "去签约", "msg": "订单还未签订协议，请前往签订协议" },
  2: { "text": '待装货', "btnText": "去装货", "msg": "订单已完成卸货请进行确认验收并付款" },
  3: { "text": '待卸货', "btnText": "去卸货", "msg": "订单已完成卸货请进行确认验收并付款" },
  4: { "text": '司机申请取消', "btnText": "去查看", "msg": "订单已完成，可对司机进行评价" },
  5: { "text": '货主申请取消', "btnText": "去查看", "msg": "订单已完成，可对司机进行评价" },
  6: { "text": '司机同意取消', "btnText": "去查看", "msg": "订单已完成，可对司机进行评价" },
  7: { "text": '货主同意取消', "btnText": "去查看", "msg": "司机申请取消该订单" },
  8: { "text": '司机拒绝取消', "btnText": "去查看", "msg": "订单已完成，可对司机进行评价" },
  9: { "text": '货主拒绝取消', "btnText": "去查看", "msg": "车队长申请取消该订单" },
  10: { "text": '通知开票', "btnText": "去查看", "msg": "司机同意取消" },
  11: { "text": '通知线下开票', "btnText": "去查看", "msg": "司机拒绝取消" },
};

export const invoiceProjectType = {
  1: "运输服务"
}
export const invoiceTypeMap = {
  1: "数电发票（专票）"
}

//企业认证审核状态
export const companyAuditMap = {
  0: {
    "status": "审核中",
    "tag": "审核中",
    "btn": "提交",
    "disabled": true,
  },
  1: {
    "status": "审核通过",
    "tag": "已认证",
    "btn": "修改",
    "disabled": false,
  }, //修改 审核成功
  2: {
    "status": "审核未通过",
    "tag": "去认证",
    "btn": "修改",
    "disabled": false,
  }, //修改 审核未通过
  3: {
    "status": "未认证",
    "tag": "去认证",
    "btn": "提交",
    "disabled": false,
  },
};

//是否可购买保险
export const insuranceMap = {
  0: { "label": "车", "desc": "根据单车货值，请确保账户余额充足。" },
  1: { "label": "吨", "desc": "每车服务费按照33吨/车估算，此运单货物保障服务费依据实际司机接单吨数计算收取，请确保账户余额充足。" },
  2: { "label": "车", "desc": "根据单车货值，请确保账户余额充足。" }
}

//关联订单状态
export const statusList = [
  { "label": "全部订单", "value": 0 },
  { "label": "待支付订单", "value": 1 },
  { "label": "已完成订单", "value": 2 },
  { "label": "可开票订单", "value": 3 },
  { "label": "已开票订单", "value": 4 },
];

//todo

//认证类型
export const AuthTypeMap =
{
  "0": {
    "label": "审核中",
    "type": "text_orange"
  },
  "1": {
    "label": "已认证",
    "type": "text_green"
  },
  "2": { "label": "已拒绝", "type": "text_red" },
  "-1": {
    "label": "未认证",
    "type": "text_black"
  },
}

//发票类型 0->个人 1->企业单位 2->非企业单位	 
export const invoiceTypeList = ["个人", "企业单位", "非企业单位"];

//订单状态：\n-1->查询全部 \n0->已接单(待签约) \n1->已签约(待装货)\n2->已装货(运输中/待卸货)\n3->已卸货(待开票)\n4->托运人申请取消订单\n5->承运人申请取消订单\n6->托运人取消订单(订单完结)\n7->承运人取消订单(订单完结)\n8->平台关闭订单(订单完结)	
export const orderStatusList = ["待签约", "待装货", "运输中", "待结算", "托运人申请取消订单 ", "承运人申请取消订单", "托运人取消订单", "承运人取消订单", "平台关闭订单 ","待评价","已确认结算"];


//开票状态\n-1->查询全部 
export const invoiceSuccessList = ["申请中", "进行中", "已开具", "提交失败", "取消申请", "线下开具", "同意线下开具",];

export const orderStepDesc = (status, name, phone, vehicleNo) => {
  switch (status) {
    case 0:
      return `您已发布货源`;
    case 1:
      return `运单已生成，承运人：${phoneDesc(name)}`;
    case 2:
      return `【${vehicleNo}】已确认装货，运输中`;
    case 3:
      return `【${vehicleNo}】已确认卸货，承运人：${phoneDesc(name)}   手机：${phoneDesc(phone)}`;
    case 4:
      return `托运人申请取消订单`;
    case 5:
      return `承运人申请取消订单`;
    case 6:
      return `托运人取消订单`;
    case 7:
      return `承运人取消订单`;
    case 8:
      return `平台关闭订单`;
       case 9:
      return `待评价`;
    default:
      return "";
  }

}
//服务费开票状态\n0->申请中\n1->已开具\n2->已拒绝	
export const serviceFeeInvoiceStatus = ["申请中","已开具","已拒绝"];
export const freightUnitTypeMap = [
  {
    text: "吨 ",
    type: 0,
  },
  {
    text: "方",
    type: 1,
  },
  {
    text: "辆",
    type: 2,
  },
]

//需求车辆 0->一辆车 1->多辆车
export const carNumMap = {
  0: "一辆车",
  1: "多辆车",
};